import { memo } from 'react'
import { Container, Text } from '@pixi/react'
import { voucherTitleTextStyle } from '../selectPopup/VoucherSelectPopupTitle'
import { FeatureToggleV2Type, formatToCommaWithLang, t, useFeatureToggleV2, usePlayerStore } from '@slot-nx/core'
import { TextStyle } from 'pixi.js'

export const yellowTextStyle = new TextStyle({
  align: 'center',
  fontWeight: '900',
  fill: '#FFDE62',
  dropShadow: true,
  dropShadowColor: 'rgba(42, 40, 40, 0.25)', // 等效rgba(134, 129, 129, 0.25)，轉成 rgba alpha = 0.4
  dropShadowBlur: 9.41,
  dropShadowAngle: Math.PI / 2, // 下方陰影
  dropShadowDistance: 9.41,
  fontFamily: 'Roboto',
  fontSize: 84.5,
})
export const VoucherTotalWinContent = memo((props: { totalPayout: number }) => {
  const currency = usePlayerStore(x => x.currency)
  const displayCurrency = useFeatureToggleV2(FeatureToggleV2Type.displayCurrency)
  const displayPayoutStr = displayCurrency
    ? `${currency}  ${formatToCommaWithLang(props.totalPayout)}`
    : `${formatToCommaWithLang(props.totalPayout)}`

  return (

    <Container name="VoucherTotalWinContent">
      <Text
        text={t('voucher_total_win_popup_title3')}
        x={0}
        y={-30}
        anchor={[0.5, 0.5]}
        name="totalWinTitle"
        style={voucherTitleTextStyle}
      />

      <Container x={0} y={80} name="payout container">
        <Text
          text={displayPayoutStr}
          x={0}
          y={0}
          anchor={[0.5, 0.5]}
          name="totalPayout"
          style={yellowTextStyle}
        />

      </Container>

    </Container>

  )
})
